module.exports = __webpack_public_path__ + "media/images/web_suite/icon_blog-155f073f13176f7c96d07ee2569e6664.png";